export const Paths = {
  DASHBOARD: "/dashboard",
  HOME: "/",
  ABOUT_US: "/about",
  ABOUT_FOUNDER: "/about/founder",
  FOR_BUSINESS: "/for-business",
  MCP: "/mcp",
  STARTUPS: "/startups",
  REFERRAL: "/referral",
  REFERRAL_CODE: "/r/:code",
  ADMIN_REFERRAL: "/admin-referral",
  PARTNERS: "/partners/:creatorSlug",
  OUR_MISSION: "/our-mission",
  CONTACT: "/contact",
  COMMUNITY: "/community",
  COMMUNITY_FEED: "/community/feed",
  COMMUNITY_POST: "/community/posts/:postId",
  COMMUNITY_PROFILE: "/community/users/:username",
  COMMUNITY_SEARCH: "/community/search",
  COMMUNITY_BLOCKED: "/community/blocked",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  DISCLOSURES: "/disclosures",
  SHARIAH_SCREENING_METHODOLOGY: "/shariah-screening-methodology",
  USERS: "/users",
  USERS_CREATE: "/users/create",
  USERS_DETAILS_ID: "/users/details/:id",
  ADMIN_ROLES_CREATE: "/admin-roles/create",
  ADMIN_ROLES_DETAILS_ID: "/admin-roles/details/:id",
  PROFILE: "/profile",
  ADMIN_ROLES: "/admin-roles",
  SUBSCRIPTIONS: "/subscriptions",
  SUBSCRIPTION_MATRIX: "/subscription-matrix",
  WEBSITE_ANALYTICS: "/website-analytics",
  STOCK_SCREENER: "/stock-screener",
  ETF_SCREENER: "/etf-screener",
  STOCK_ANALYSES: "/stock-analyses",
  STOCK_REPORT: "/stock-report",
  TOP_HALAL_STOCKS: "/top-halal-stocks",
  PORTFOLIOS: "/portfolios",
  READY_MADE_PORTFOLIO: "/ready-made-portfolio",
  READY_MADE_PORTFOLIO_ID: "/ready-made-portfolio/:id",
  READY_MADE_PORTFOLIO_STOCKS: "/ready-made-portfolio/:id/stocks",
  FINANCE: "/finance",
  ARTICLES: "/articles",
  ARTICLES_CREATE: "/articles-create",
  ARTICLES_CREATE_ID: "/articles-create/:slug",
  WEBINARS: "/webinars",
  WEBINARS_CREATE: "/webinars-create",
  SUPPORT_TICKETS: "/support-tickets",
  NOTIFICATIONS: "/notifications",
  NOTIFICATIONS_CREATE: "/notifications-create",
  NOTIFICATIONS_DETAILS_ID: "/notifications/details/:id",
  NOTIFICATIONS_SETTINGS: "/notifications-settings",
  SETTINGS: "/settings",
  NOT_FOUND: "*",
  LOGIN: "/login",
  SIGN_UP: "/sign-up",
  VERIFY_EMAIL: "/verify-email",
  FORGOT_PASSWORD: "/forgot-password",
  CHECK_YOUREMAIL: "/check-your-email",
  GOOGLE_EXTERNAL_AUTH: "/auth/google-external",
  SET_NEW_PASSWORD: "/set-new-password",
  PASSWORD_RESET: "/password-reset",
  PERSONAL_INFO: "/personal-info",
  REPORT_DETAIL_ID: "/report-detail/:id",
  EDIT_REPORT_ID: "/edit-report/:id",
  ARTICLE_DETAIL: "/article-detail/slug/:slug",
  WEBINAR_DETAIL_ID: "/webinar-detail/:id",
  CREATE_REPORT: "/create-report",
  CREATE_REPORT_ID: "/create-report/:id",
  REPORTS: "/reports",
  REPORTS_CREATE: "/reports/create",
  REPORTS_DETAILS_ID: "/reports/details/:id",
  ACADEMY: "/academy",
  COURSE_INFO_ID: "/course-info/:id",
  COURSE_DASHBOARD_ID: "/course-dashboard/:id",
  MARKET_NEWS: "/market-news",
  SCREENING: "/screening",
  INSIDER_BY_SECTOR: "/insider-by-sector",
  DIVIDEND: "/dividend",
  INVESTING_CALCULATOR: "/investing-calculator",
  ZAKAT_CALCULATOR: "/zakat-calculator",
  PURIFICATION_CALCULATOR: "/purification-calculator",
  MY_PORTFOLIO: "/my-portfolio",
  PORTFOLIO_TRACKING: "/portfolio-tracking",
  PORTFOLIO_BACKTESTING: "/portfolio-backtesting",
  WEBINARS_CREATE_ID: "/webinars-create/:id",
  COURSES_CREATE_ID: "/courses-create/:id",
  COURSES_DETAIL_ID: "/courses-detail/:id",
  COURSES_CREATE: "/courses-create",
  COURSES_STATS_ID: "/courses-stats/:id",
  SUMMARY: "/summary",
  SYMBOL: "/symbol/:symbol",
  ETF: "/etf/:symbol",
  AKINDA_AI: "/akinda_ai",
  GAMES: "/games",
  BACKTESTING: "/backtesting",
  ARTICLE_CATEGORIES: "/article-categories",
  ARTICLE_CATEGORIES_CREATE: "/article-categories/create",
  ARTICLE_CATEGORIES_CREATE_ID: "/article-categories/create/:id",
  PUBLIC_PORTFOLIO: "/public/portfolio-folders/:hash/portfolios",
  PAYMENT_DETAILS: "/payment-details/:planId",
  SUBSCRIPTION_RESULT: "/subscription-result",
  SUBSCRIBE_PLAN_TYPE: "/subscribe/:planType",
  MY_CARDS: "/my-cards",
  PROMOCODES: "/promocodes",
  PROMOCODES_DETAILS_ID: "/promocodes/details/:id",
  PROMOCODES_CREATE: "/promocodes/create",
  PROMOCODES_CREATE_ID: "/promocodes/create/:id",
  ONBOARDING_QUESTIONS: "/onboarding-questions",
  ONBOARDING_QUESTIONS_CREATE: "/onboarding-questions/create",
  ONBOARDING_QUESTIONS_CREATE_ID: "/onboarding-questions/create/:id",
  ONBOARDING_STATS: "/onboarding-stats",
};

export const PathGenerators = {
  USERS_DETAILS_ID: (id: string) => Paths.USERS_DETAILS_ID.replace(":id", id),
  ADMIN_ROLES_DETAILS_ID: (id: string) =>
    Paths.ADMIN_ROLES_DETAILS_ID.replace(":id", id),
  REPORT_DETAIL_ID: (id: string) => Paths.REPORT_DETAIL_ID.replace(":id", id),
  EDIT_REPORT_ID: (id: string) => Paths.EDIT_REPORT_ID.replace(":id", id),
  ARTICLE_DETAIL: (slug: string) => Paths.ARTICLE_DETAIL.replace(":slug", slug),
  WEBINAR_DETAIL_ID: (id: string) => Paths.WEBINAR_DETAIL_ID.replace(":id", id),
  NOTIFICATIONS_DETAIL_ID: (id: string) =>
    Paths.NOTIFICATIONS_DETAILS_ID.replace(":id", id),
  COURSE_INFO_ID: (id: string) => Paths.COURSE_INFO_ID.replace(":id", id),
  COURSE_DASHBOARD_ID: (id: string) =>
    Paths.COURSE_DASHBOARD_ID.replace(":id", id),
  ARTICLES_CREATE_ID: (slug: string) =>
    Paths.ARTICLES_CREATE_ID.replace(":slug", slug),
  WEBINARS_CREATE_ID: (id: string) =>
    Paths.WEBINARS_CREATE_ID.replace(":id", id),
  COURSES_CREATE_ID: (id: string) => Paths.COURSES_CREATE_ID.replace(":id", id),
  COURSES_DETAIL_ID: (id: string) => Paths.COURSES_DETAIL_ID.replace(":id", id),
  COURSES_STATS_ID: (id: string) => Paths.COURSES_STATS_ID.replace(":id", id),
  REPORTS_DETAILS_ID: (id: string) =>
    Paths.REPORTS_DETAILS_ID.replace(":id", id),
  SYMBOL: (symbol: string) => Paths.SYMBOL.replace(":symbol", symbol),
  ETF: (symbol: string) => Paths.ETF.replace(":symbol", symbol),
  CREATE_REPORT_ID: (id: string) => Paths.CREATE_REPORT_ID.replace(":id", id),
  ARTICLE_CATEGORIES_CREATE_ID: (id: string) =>
    Paths.ARTICLE_CATEGORIES_CREATE_ID.replace(":id", id),
  PROMOCODES_CREATE_ID: (id: string) =>
    Paths.PROMOCODES_CREATE_ID.replace(":id", id),
  PROMOCODES_DETAILS_ID: (id: string) =>
    Paths.PROMOCODES_DETAILS_ID.replace(":id", id),
  ONBOARDING_QUESTIONS_CREATE_ID: (id: string) =>
    Paths.ONBOARDING_QUESTIONS_CREATE_ID.replace(":id", id),
  PUBLIC_PORTFOLIO: (hash: string) =>
    Paths.PUBLIC_PORTFOLIO.replace(":hash", hash),
  READY_MADE_PORTFOLIO_ID: (id: string) =>
    Paths.READY_MADE_PORTFOLIO_ID.replace(":id", id),
  READY_MADE_PORTFOLIO_STOCKS: (id: string) =>
    Paths.READY_MADE_PORTFOLIO_STOCKS.replace(":id", id),
  SUBSCRIBE_PLAN_TYPE: (planType: string) =>
    Paths.SUBSCRIBE_PLAN_TYPE.replace(":planType", planType),
  PAYMENT_DETAILS: (planId: number) =>
    Paths.PAYMENT_DETAILS.replace(":planId", planId.toString()),
  PARTNERS: (creatorSlug: string) =>
    Paths.PARTNERS.replace(":creatorSlug", creatorSlug),
  COMMUNITY_POST: (postId: string) =>
    Paths.COMMUNITY_POST.replace(":postId", postId),
  COMMUNITY_PROFILE: (username: string) =>
    Paths.COMMUNITY_PROFILE.replace(":username", username),
};
